module.exports = __webpack_public_path__ + "static/media/game_dikha.041fd575.mp4";